export default __webpack_public_path__ + "static/media/cardiac.a3f07c2d.svg";